import FiveCardHandParent from '@/services/five-card-hands/five-card-hand-parent/FiveCardHandParent';

export default class MadeHandParent extends FiveCardHandParent {
  constructor(argsObj) {
    super(argsObj);
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/five-card-hand-parent/MadeHandParent.js